import React from "react";
import "../printStyles.css";

function DriverDailyWalkaroundCheckLog() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #DriverDailyWalkaroundCheckLogForm, #DriverDailyWalkaroundCheckLogForm * {
              visibility: visible;
            }
            #DriverDailyWalkaroundCheckLogForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="DriverDailyWalkaroundCheckLogForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Driver Daily Walkaround Check Sheets Log</h3>

        <form>
          {/* Managed By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managedBy">
              Managed By (Name):
            </label>
            <input
              type="text"
              id="managedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Daily Checkboxes */}
          <div className="mb-4">
            <h5 className="text-lg font-medium mb-2 text-gray-700">Days of the Week:</h5>
            <div className="grid grid-cols-7 gap-4 text-center">
              <div className="flex flex-col items-center">
                <label htmlFor="mon" className="text-sm font-medium text-gray-500">Mon</label>
                <input type="checkbox" id="mon" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="tues" className="text-sm font-medium text-gray-500">Tues</label>
                <input type="checkbox" id="tues" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="wed" className="text-sm font-medium text-gray-500">Wed</label>
                <input type="checkbox" id="wed" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="thurs" className="text-sm font-medium text-gray-500">Thurs</label>
                <input type="checkbox" id="thurs" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="fri" className="text-sm font-medium text-gray-500">Fri</label>
                <input type="checkbox" id="fri" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="sat" className="text-sm font-medium text-gray-500">Sat</label>
                <input type="checkbox" id="sat" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
              <div className="flex flex-col items-center">
                <label htmlFor="sun" className="text-sm font-medium text-gray-500">Sun</label>
                <input type="checkbox" id="sun" className="form-checkbox h-5 w-5 text-blue-500 rounded" />
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Add any additional notes here..."
            />
          </div>

          {/* Overall Review */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="overallReview">
              Overall Review:
            </label>
            <div className="flex space-x-4 mt-2">
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallReview" value="AllComplete" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">All Complete</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallReview" value="MissingSheets" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Missing Sheets</span>
              </label>
            </div>
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DriverDailyWalkaroundCheckLog;
